import { Outlet, createRootRoute } from '@tanstack/react-router'
import { Button } from '../ui/Button'
import { Link } from '@tanstack/react-router'
import { cx } from '../ui/cx'
import { textLinkClass } from '../ui/navigation'
import { StatePage } from '../ui/states'

function NotFound() {
  return (
    <StatePage illustration="cactus">
      <h1 className="font-heading text-2xl font-semibold text-foreground">Page not found</h1>
      <p className="max-w-prose text-base text-muted-foreground">
        Check the address, or return to your workspaces.
      </p>
      <Link to="/" className={cx('px-1.5 py-1 text-sm', textLinkClass)}>
        Go to your workspaces
      </Link>
    </StatePage>
  )
}

function RouteError({ reset }: { readonly reset: () => void }) {
  return (
    <StatePage illustration="cactus" alert>
      <h1 className="font-heading text-2xl font-semibold text-foreground">
        This page could not be shown
      </h1>
      <Button variant="secondary" onClick={reset}>
        Try again
      </Button>
    </StatePage>
  )
}

export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: NotFound,
  errorComponent: ({ reset }) => <RouteError reset={reset} />,
})
